import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@jsverse/transloco';
import { IconDirective } from 'shared/ui-common';

import { ComponentType } from '@treetop/shared/model';

import { FilterOptions } from '../model/filter-options';

@Component({
  selector: 'shared-search-filter',
  standalone: true,
  imports: [TranslocoModule, MatIconModule, IconDirective],
  templateUrl: './search-filter.component.html',
  styleUrls: ['./search-filter.component.scss'],
})
export class SearchFilterComponent {
  @HostBinding('class.search-filter') class = true;

  @Input() options: FilterOptions;
  @Input() value: FilterOptions = {
    possibleComponentTypes: [],
    taxonomyId: null,
  };

  @Output() filterChanged = new EventEmitter<FilterOptions>();

  protected componentTypePropertyMap: { [key in ComponentType]: { icon: string; translationKey: string; ariaLabel: string } } = {
    [ComponentType.ActivityDefinition]: { icon: 'medkit', translationKey: 'ActivityDefinitions', ariaLabel: 'Activity Definitions' },
    [ComponentType.ConditionDefinition]: null,
    [ComponentType.ObservationDefinition]: {
      icon: 'microscope',
      translationKey: 'ObservationDefinitions',
      ariaLabel: 'Observation Definitions',
    },
    [ComponentType.FindingDefinition]: { icon: 'clipboard-list', translationKey: 'FindingDefinitions', ariaLabel: 'Finding Definitions' },
  };

  protected addOrRemoveComponentType(componentType: ComponentType): void {
    const componentTypes = this.value?.possibleComponentTypes ?? [];

    const index = componentTypes.indexOf(componentType);
    if (index === -1) {
      componentTypes.push(componentType);
    } else {
      componentTypes.splice(index, 1);
    }

    this.filterChanged.emit(this.value);
  }

  protected taxonomyFilterChanged(checkboxEvent: boolean): void {
    this.value.taxonomyId = checkboxEvent ? this.options.taxonomyId : null;
    this.filterChanged.emit(this.value);
  }
}
